import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { MediaBreakPointDown, MediaBreakPointUp } from '@lean-body/components/styles';
export const LiveChat = (props) => {
    const styles = StyleSheet.create({
        liveChatContainer: {
            textAlign: 'center',
            marginBottom: 40,
            [MediaBreakPointUp.XL]: {
                marginBottom: 40,
            },
        },
        iframe: {
            width: '100%',
            height: 370,
            border: 'none',
            [MediaBreakPointDown.XS]: {
                height: 320,
            },
            [MediaBreakPointUp.SM]: {
                height: 409,
            },
            [MediaBreakPointUp.XL]: {
                border: 'lightgray solid 1px',
            },
        },
    });
    return (React.createElement("div", { className: css(styles.liveChatContainer) },
        React.createElement("iframe", { src: props.src, className: css(styles.iframe) })));
};
